import React from 'react';
import PropTypes from 'prop-types';
import StarRounded from '@material-ui/icons/StarRounded';
import StarHalfRounded from '@material-ui/icons/StarHalfRounded';
import {ReviewStars} from './styles';

const Stars = ({value, max, sentiment}) => {
  const rounded = Math.round(value * 2) / 2;
  return (
    <ReviewStars
      $sentiment={sentiment}
      aria-label={`${value} out of ${max} stars`}
    >
      {Array.from({length: max}).map((_, i) => {
        let Icon = StarRounded;
        let className = 'star-empty';
        if (i + 1 <= rounded) {
          className = 'star-filled';
        } else if (i + 0.5 === rounded) {
          Icon = StarHalfRounded;
          className = 'star-filled';
        }
        // eslint-disable-next-line react/no-array-index-key
        return <Icon key={i} className={className} />;
      })}
    </ReviewStars>
  );
};

Stars.propTypes = {
  value: PropTypes.number.isRequired,
  max: PropTypes.number,
  sentiment: PropTypes.oneOf(['positive', 'negative'])
};

Stars.defaultProps = {
  max: 5,
  sentiment: 'positive'
};

export default Stars;
